import { TeacherService } from '@openeducation/oe-it-services';
import type {
  LiveClassPendingFeedback,
  PersonProfile,
} from '@openeducation/oe-it-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';

type PendingFeedbacksProps = {
  teacherProfile: PersonProfile | null;
};
export const usePendingFeedbacks = ({
  teacherProfile,
}: PendingFeedbacksProps) => {
  const { environment } = useEnvironmentContext();

  const {
    data: pendingFeedbacks,
    isLoading: isLoadingPendingFeedbacks,
    isError: isErrorPendingFeedbacks,
    refetch: reFetchPendingFeedbacks,
  } = useQuery<LiveClassPendingFeedback[]>(
    ['pending-feedbacks', teacherProfile?.sfdcFacultyId],
    async () =>
      TeacherService.getFeedbacksByTeacherId(
        environment,
        teacherProfile?.sfdcFacultyId
      ),
    {
      enabled: !!teacherProfile?.sfdcFacultyId,
    }
  );

  return {
    pendingFeedbacks,
    isLoadingPendingFeedbacks,
    isErrorPendingFeedbacks,
    reFetchPendingFeedbacks,
  };
};
